import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=5ab73090&scoped=true&"
import script from "./StatisticsPage.vue?vue&type=script&lang=js&"
export * from "./StatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./Style/statistics-page.scss?vue&type=style&index=0&id=5ab73090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab73090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab73090')) {
      api.createRecord('5ab73090', component.options)
    } else {
      api.reload('5ab73090', component.options)
    }
    module.hot.accept("./StatisticsPage.vue?vue&type=template&id=5ab73090&scoped=true&", function () {
      api.rerender('5ab73090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/Page/StatisticsPage.vue"
export default component.exports